export class Pagination {
  totalCount: number;
  sum: number;
  pageSize: number;
  pageNumber: number;
  pageSizeOptions: number[] = [10, 25, 50];

  constructor() {
    this.totalCount = 0;
    this.sum = 0;
    this.pageSize = 10;
    this.pageNumber = 1;
  }
}

export class Paginated<T> extends Pagination {
  resultSet: T[];
}
